<template>
  <div id="page-campaign-image-list">
    <div>
      <vx-card v-if="addVisible">
        <campaign-image-add
          :idCampaign="idCampaign"
          v-on:state-changed="refreshList"
          v-on:closed="addImageClosed"
        />
      </vx-card>
      <div v-show="!addVisible">
        <div class="mb-6">
          <vs-button
            @click="startAddImage"
            color="primary"
            type="border"
            icon="add"
            >{{ $t("CampaignImage.AddImage") }}</vs-button
          >
        </div>
        <div class="flex flex-wrap items-center">
          <DxList
            :data-source="customDataSource"
            height="100%"
            :ref="listRefKey"
            @item-click="onItemClick"
          >
            <template #item="{ data: item }">
              <div class="campaign-image">
                <img :src="item.urls.thumbnailLarge" :alt="item.imageName" />
                <div>
                  <span
                    v-for="cat in item.categories"
                    :key="cat"
                    class="badge mr-2"
                    >{{ cat }}</span
                  >
                </div>

                <div class="image-type">{{ item.idImageType }}</div>
                <vs-button
                  class="ml-4 float-right"
                  type="border"
                  @click="confirmDeleteImage"
                  >{{ $t("Delete") }}</vs-button
                >
              </div>
            </template>
            <DxItemDragging
              :allow-reordering="true"
              :on-reorder="onReorder"
              :data="data"
            />
          </DxList>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moduleCampaignManagement from '@/store/campaign-management/moduleCampaignManagement.js'
import CustomStore from 'devextreme/data/custom_store'
import { DxPopup } from 'devextreme-vue/popup'
import { notifyMixin } from '@/mixins/notifyMixin'
import DxList, { DxItemDragging } from 'devextreme-vue/list'
import CampaignImageAdd from './CampaignImageAdd'

const listRefKey = "grid-campaign-images"
export default {
  name: 'strategy-list',
  mixins: [notifyMixin],
  props: {
    idCampaign: {
      type: Number
    }
  },
  components: {
    DxPopup,
    DxList,
    DxItemDragging,
    CampaignImageAdd
  },
  data () {
    const customDataSource = new CustomStore({
      key: 'id',
      load: () => {
        return this.$store
          .dispatch(
            'campaignManagement/fetchImages',
            this.idCampaign
          )
          .then((res) => {
            this.data = res.data
            return res.data
          })
          .catch((error) => {
            this.notifyError(error)
          })
      }
    })

    return {
      customDataSource,
      listRefKey,
      addVisible: false,
      selectedId: 0,
      data: []
    }
  },
  watch: {
  },
  computed: {
  },
  methods: {
    refreshList () {
      this.addVisible = false
      console.log(`refreshing list ${this.$refs[listRefKey]}`)
      const list = this.$refs[listRefKey].instance
      return list.reload()
    },
    startAddImage () {
      this.addVisible = true
    },
    addImageClosed () {
      this.addVisible = false
    },
    onItemClick (e) {
      this.selectedId = e.itemData.id
    },
    onReorder (e) {
      this.$vs.loading()
      e.promise = this.$store
        .dispatch(
          'campaignManagement/reorderImages',
          {
            idCampaign: this.idCampaign,
            fromIndex: e.fromIndex,
            toIndex: e.toIndex
          }
        )
        .then(() => {
          this.$vs.loading.close()
          return this.refreshList()
        })
        .catch((error) => {
          this.notifyError(error)
          this.$vs.loading.close()
        })
    },
    confirmDeleteImage () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: this.$t('CampaignImage.Delete'),
        text: this.$t('CampaignImage.DeleteQuestion'),
        accept: this.deleteImage,
        acceptText: this.$t('Delete'),
        cancelText: this.$t('Cancel')
      })
    },
    deleteImage () {
      this.$vs.loading()
      this.$store
        .dispatch(
          'campaignManagement/deleteImage',
          this.selectedId
        )
        .then(() => {
          this.notifySuccess(this.$t('CampaignImage.Deleted'))
          this.refreshList()
          this.$vs.loading.close()
        })
        .catch((error) => {
          this.notifyError(error)
          this.$vs.loading.close()
        })
    },
  },
  mounted () { },
  created () {
    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        'campaignManagement',
        moduleCampaignManagement
      )
      moduleCampaignManagement.isRegistered = true
    }

  }
}
</script>
<style scoped>
.badge {
  background-color: #253487;
  padding: 9px 12px;
  line-height: 12px;
  font-weight: 500;
  color: #fff;
  font-size: 12px;
  border-radius: 20px;
}

.list-container {
  min-height: 440px;
  height: auto;
  position: absolute;
  top: 0;
  bottom: 0;
}

.campaign-image {
  height: 65px;
}

.campaign-image > img {
  height: 150px;
  width: 150px;
  float: left;
}

.campaign-image > div {
  padding-left: 10px;
  vertical-align: top;
  line-height: 65px;
  font-size: 15px;
  float: left;
}

.campaign-image > div.image-type {
  float: right;
  font-size: 18px;
}
</style>